<template>
	<section>
		<div v-if="showParentView('page-app')">
			<header-page
				name="apps"
				:title="$route.meta.title"
			/>
			<app-list
				:columns="columns"
				:current-page="currentPage"
				:rows="table.rows"
				:last-page="table.lastPage"
				@change-page="changePage"
				@on-delete="loadData(`project/${codeProject}/apps`)"
				@on-search="onSearch($event, `project/${codeProject}/apps`)"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import appList from '@/components/apps/app-list';

function created() {
	this.loadData(`project/${this.codeProject}/apps`);
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData(`project/${this.codeProject}/apps`);
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CA',
				text: 'Crear App',
				icon: 'apps',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Aplicación', checked: true, visible: true },
			{ id: 2, name: 'Código', checked: true, visible: true },
			{ id: 3, name: 'Repositorio', checked: true, visible: true },
			{ id: 4, name: 'Módulos', checked: true, visible: true },
			{ id: 5, name: 'Estado', checked: true, visible: true },
			{ id: 6, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		currentPage: 1,
	};
}

function openModal() {
	this.goTo('page-app-new');
}

export default {
	name: 'page-app',
	created,
	components: {
		appList,
		quickActions,
	},
	data,
	methods: {
		changePage,
		openModal,
	},
	props: {
		codeProject: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-app') {
					this.loadData(`project/${this.codeProject}/apps`);
				}
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/apps/page-app.vue